/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOrderingProfileCatalog} from '../api'

 export const useQueryGetOrderingProfileCatalog = createReactQueryHook('getOrderingProfileCatalog', getOrderingProfileCatalog)
